const fullAccess = [
  'Chief',
  'Admin',
  'HosesChief',
  'HosesAdmin',
  'HosesEngineer',
];

export const HOSES_ROLES_VIEWS_PERMISSIONS = {
  sharedActions: {
    schedulingMachinesOperator: ['Admin', 'HosesOperator'],
    schedulingOnlyTrimming: [
      'Admin',
      'HosesTrimming',
      'HosesQC',
      'QualityControl',
      'QualityControlInspector',
    ],
    /**
     * @description Los roles descritos aqui podran visualizar la vista de cantidades rechazadas
     */
    qcRejected: [
      ...fullAccess,
      'HosesRejected',
      'HosesSupervisor',
      'HosesLeader',
      'QualityControl',
      'QualityControlInspector',
    ],
    /**
     * @description Los roles descritos aqui podran visualizar la vista de QC, la cual esta separada
     * en su vista unica
     */
    schedulingQualityControl: [
      ...fullAccess,
      'Chief',
      'HosesQC',
      'QualityControl',
      'QualityControlInspector',
    ],
    /**
     * @description Los roles descritos aqui podran visualizar la vista de hornos
     */
    oven: [...fullAccess, 'HosesTrimming', 'HosesSupervisor', 'HosesLeader'],
    validation: [...fullAccess, 'HosesQC', 'HosesSupervisor', 'HosesLeader'],
    packingBox: [
      ...fullAccess,
      'HosesQC',
      'HosesLabelOperator',
      'LabelOperator',
      'QualityControl',
    ],
    molds: [...fullAccess, 'HosesSupervisor'],
    addQcData: [...fullAccess, 'QualityControl'],
    destinations: ['Admin', 'Chief'],
  },

  routerActions: {
    scheduling: [...fullAccess, 'HosesSupervisor', 'HosesLeader'],
  },

  sideNavActions: {
    root: [
      ...fullAccess,
      'HosesOperator',
      'HosesTrimming',
      'HosesQC',
      'HosesOperator',
      'HosesSupervisor',
      'HosesLeader',
      'QualityControl',
      'QualityControlInspector',
    ],
  },
};
